import gql from 'graphql-tag';

export const likePostMutation = gql`
  mutation LikePost($input: LikePostMutationInput!) {
    likePost(input: $input) {
      post {
        _id: externalId
        likedByCurrentUser
        likesCount
      }
    }
  }
`;
